<template>
    <defect-detail is_supplier></defect-detail>
</template>
<script>
    const DefectDetail = () => import('../detail.vue')
    export default {
        name: "defect-report-detail-supplier",
        components: {
            DefectDetail
        }
    }
</script>